import { createSlice } from "@reduxjs/toolkit";

export const patientCompareSlice = createSlice({
    name: 'compare',
    initialState: {
        checked: false,
        value: {},
        theme: []
    },
    reducers: {
        setCompareValue: (state, action) => {
            state.value = action.payload;
        },
        setCompareChecked: (state, action) => {
            state.checked = action.payload;
        },
        setThemeCompareSelectedValue: (state, action) => {
            state.theme = action.payload;
        }
    }
})

export const { setCompareValue, setCompareChecked, setThemeCompareSelectedValue } = patientCompareSlice.actions;

export const getCompareValue = (state) => state.compare.value;
export const getCompareChecked = (state) => state.compare.checked;
export const getThemeCompareSelectedValue = (state) => state.compare.theme;

export default patientCompareSlice.reducer;